import {useParams} from 'react-router'
import {dialogApi} from '../../../../api/dialogApi'
import {useCallback, useEffect, useState} from 'react'
import {UserAvatarCarousel} from '../UserAvatarCarousel/UserAvatarCarousel'
import styles from './UserWelcomePage.module.scss'
import {useWuShowToast} from '@npm-questionpro/wick-ui-lib'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {DIALOG} from '../../../../Translation/English/dialog'
import type {IStoredDialogUserAvatar} from '../../../../types'

interface IUserWelcomePageProps {
  setShowWelcomePage: (show: boolean) => void
}

export const UserWelcomePage = ({
  setShowWelcomePage,
}: IUserWelcomePageProps): React.ReactElement => {
  const saveDialogUserAvatarMutation = dialogApi.useSaveDialogUserAvatar()
  const wt = useWt()
  const {showToast} = useWuShowToast()
  const {dialogId} = useParams<{dialogId: string}>()
  const {data: carouselAvatarUsernames} = dialogApi.useDialogUserAvatar()
  const [usernames, setUsernames] = useState<string[] | undefined>(undefined)
  const [selectedUsername, setSelectedUsername] = useState<string | undefined>(
    undefined,
  )

  useEffect(() => {
    if (carouselAvatarUsernames?.length) {
      setSelectedUsername(carouselAvatarUsernames[0])
      setUsernames(carouselAvatarUsernames)
    }
  }, [carouselAvatarUsernames])

  const continueToDialog = useCallback(async (): Promise<void> => {
    const resp = await saveDialogUserAvatarMutation
      .mutateAsync({
        username: selectedUsername,
        avtarImage: '',
        dialogId,
      })
      .catch(() => {
        showToast({
          message: wt(DIALOG.somethingWentWrongTryAgain),
          variant: 'error',
        })
        return null
      })
    if (!resp) return
    if (resp?.id) {
      const storedAvatars = localStorage.getItem(`dialogUserAvatars`)
        ? JSON.parse(localStorage.getItem(`dialogUserAvatars`)!)
        : []
      const userDetails = {
        dialogUserAvatarId: resp.id,
        dialogAvatarImageId: resp.id,
        username: selectedUsername,
        avtarImage: '',
        orgId: resp.orgId,
      }
      const filteredAvatars = storedAvatars.filter(
        (avatar: IStoredDialogUserAvatar) => avatar.orgId !== userDetails.orgId,
      )
      filteredAvatars.push(userDetails)
      localStorage.setItem(`dialogUserAvatars`, JSON.stringify(filteredAvatars))
      setShowWelcomePage(false)
    }
  }, [
    showToast,
    wt,
    saveDialogUserAvatarMutation,
    selectedUsername,
    dialogId,
    setShowWelcomePage,
  ])

  return (
    <div className={styles.userWelcome}>
      <div className={styles.title}>{wt(DIALOG.welcomeToConversations)}</div>
      <div className={styles.text}>{wt(DIALOG.welcomeText2)}</div>
      <div className={styles.avatar}>
        <div className={styles.userDetails}>
          <UserAvatarCarousel
            usernames={usernames}
            onUsernameChange={setSelectedUsername}
          />
        </div>
      </div>
      <div className={styles.btnWrapper}>
        <div className={styles.btn} onClick={continueToDialog}>
          {wt(DIALOG.continue)}
        </div>
      </div>
    </div>
  )
}
